import APIs from '../../api'
import { apiClient } from '../../api/client'

// GET `${CUSTOMER_URL}/users/me`
// Returns the current authenticated user's profile. The apiClient baseURL is
// `VITE_API_BASE_URL`, but the backend serving /users/me lives on
// `VITE_APP_CUSTOMER_API_URL` — we resolve that explicitly so the call hits
// the right host regardless of the proxy config.
export const getMyProfile = async () => {
  // The customer API URL already includes `/api` — strip it so axios doesn't
  // double the prefix when we hand it a relative path.
  const res = await apiClient.get(APIs.AUTH.me)
  return res?.data?.data || null
}

// PUT `${CUSTOMER_URL}/guardian-users/profile`
// Body contract: UserProfileDTO — { name, phoneNo?, address: { addressLine1,
// addressLine2?, city, state, country, zip } }. The endpoint lives on the
// customer URL, but it isn't exposed via the GUARDIAN_USERS list — keep it
// as its own entry so callers don't accidentally hit `/guardian-users/:uuid`.
export const updateMyProfile = async (payload) => {
  const res = await apiClient.put(APIs.GUARDIAN_USERS.profile, payload)
  return res?.data?.data || null
}

export const formatAddress = (address) => {
  if (!address) return ''
  const parts = [
    address.addressLine1,
    address.addressLine2,
    address.city,
    address.state,
    address.country,
    address.zip,
  ].filter(Boolean)
  return parts.join(', ')
}
